import { IntegrityMonitorRulesAppWebComponent } from './component/IntegrityMonitorRulesAppWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_APP } from '../../../webcomponents.constants';

export { IntegrityMonitorRulesAppWebComponent };

window.customElements.define(WEB_COMPONENT_INTEGRITY_MONITOR_RULES_APP, IntegrityMonitorRulesAppWebComponent);
